<d-accordion
  class="da-menu"
  [data]="data"
  [menuItemTemplate]="menuTemplate"
  [linkType]="'routerLink'"
  [accordionType]="'embed'"
  [autoOpenActiveMenu]="true"
></d-accordion>

<ng-template #menuTemplate let-item="item" >
    <i  [class]="item.menuIcon" style="margin-right: 8px"></i>
    {{ item.title }}
</ng-template>
